<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Tendering Proces - Step 1 of 4
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                <button   class="btn btn-primary mr-1" @click="nextStep()"><i class="fa fa-forward"></i> Next Step</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col md="6">
                        <b-input-group>
                            <b-input-group-prepend><label>Tendering Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.nomor" readonly></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col md="6">                            
                        <b-input-group>
                            <b-input-group-prepend><label>Tendering Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tanggal" type="date"  :state="!$v.model.tanggal.$error"></b-form-input>                                        
                        </b-input-group>
                        </b-col>
                    </b-row >    
                    <b-input-group >
                        <b-input-group-prepend><label>Note/Description</label></b-input-group-prepend>
                        <b-form-input v-model="model.uraian"  placeholder="Note/Description" :state="!$v.model.uraian.$error"></b-form-input>
                    </b-input-group>
                    <b-form-row>
                        <b-col md="12">
                            <b-input-group >
                                <b-input-group-prepend><label><strong>Requisition(PR) No.</strong></label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.requisition" :state="!$v.model.requisition.$error"></b-form-input>
                                <b-input-group-append>
                                <b-btn text="Button" @click="lkuRequisitionShow=true" :disabled="(this.requestOrd.total>0)">
                                    <i class="fa fa-search"></i>
                                </b-btn>
                                </b-input-group-append>
                            </b-input-group>
                        </b-col>
                    </b-form-row>                      
                </b-col>
              </b-row>
                <div class="tbl-wrap">
                <b-table
                    class="mb-0"
                    ref="tblRequestOrd"
                    outlined
                    striped hover small
                    :items="requestOrd.items"
                    :fields="requestOrd.fields"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(requestdate)="data">
                        {{data.item.requestdate  | moment("DD MMM YYYY") }}
                        </template>
                        <template v-slot:cell(action)="data">
                            <div class="text-center">
                            <a href="javascript:void(0)" class="text-danger" @click="delRequestOrd(data.index)">
                                <i class="fa fa-trash"></i>
                            </a>
                            </div>
                        </template>
                </b-table>
                </div>                      
                <h4 class="mt-2">Item Requested</h4>          
                <div class="tbl-wrap" style="min-height: 200px !important;">
                    <b-table
                        class="mb-0"
                        ref="tblRequestItem"
                        outlined
                        striped hover small 
                        style="font-size:smaller;"
                        :items="requestItem.items"
                        :fields="requestItem.fields"
                      >
                          <template v-slot:cell(index)="data">
                            {{data.index + 1}}
                          </template>
                        <template v-slot:cell(description)="data">
                            <pre>{{data.item.description}}</pre>
                        </template>
                        <template v-slot:cell(jasa)="data">
                            <span v-if="(data.item.jasa==1)">Service</span>
                            <span v-else>Material</span>
                        </template>

                        <template v-slot:cell(quantity)="data">
                            {{data.item.quantity}} {{data.item.invunitom}}
                        </template>
                        <template v-slot:cell(groupNo)="data">
                            <b-form-input v-model="data.item.groupNo">
                            </b-form-input>
                        </template>  
                        <template v-slot:cell(HEAD_selected)="data">
                             <b-form-checkbox @click.native.stop v-model="selectAllItem" style="width:20px;">select 
                            </b-form-checkbox>
                        </template>
                        
                        <template v-slot:cell(selected)="data">
                            <b-form-checkbox @click.stop v-model="data.item.selected"  style="width:20px;">
                            </b-form-checkbox>
                        </template>                                            
                        </b-table>     
                    <!-- <b-form-row class="ml-1 mr-1">
                      <b-col cols="6">
                        <div>
                          Showing
                          {{(requestItem.page - 1) * requestItem.limit + 1}}
                          to
                          {{requestItem.page * requestItem.limit}}
                          of
                          {{requestItem.total}}
                          entries
                        </div>    
                      </b-col>
                      <b-col cols="6">
                        <b-pagination
                          align="right"
                          :total-rows="requestItem.total"
                          :per-page="requestItem.limit"
                          v-model="requestItem.page"
                        ></b-pagination>
                      </b-col>
                    </b-form-row> -->
                </div>
            <b-row class="justify-content-center mb-2">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="saveAndNext()"><i class="fa fa-forward"></i> Save  & Next </button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </b-row>

        </b-card>
        <b-modal v-model="lkuRequisitionShow" size="lg" :hide-footer="true" title="List of APPROVED Requisition" :centered="true">
            <lku-pr @click="onSelectLkuRequest"></lku-pr>
        </b-modal>        
        <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    </div>
</template>
<style lang="scss">
    .tbl-wrap {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;
        min-height: 100px;
        border: 1px solid silver;
    }
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;
        min-height: 100px;
        border: 1px solid silver;
        table {
            font-size: smaller;
            th {
                border: 1px solid silver;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            tbody tr:hover {
                background-color: rgba(91,192,222, 0.2) !important;
                cursor: default;
            }

            td {
                border: 1px solid silver;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
        }
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 80px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import lkuPr from "../lookup/lkuPr";
import proctender from "../../apis/proctender";
// import procure from "../../apis/procure";
import { validationMixin } from "vuelidate";
import { required, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { Loading, lkuPr},
  mixins: [validationMixin],
  validations: {
        model: {
            // nomor: { required },
            tanggal: { required },
            uraian: { required },
            requisition: { required },
        },
        requestOrdObj: {
            // requestno: { required },
        },
  }, 
  data() {
    return {
        saveEnabled:true,
        stepNextEnabled:false,
        selectAllItem:false,
        isLoading:false,
        lkuRequisitionShow:false,
        uanguser: this.$store.state.user.matauang,
        model:{nomor:'',tanggal:moment().format('YYYY-MM-DD'),
                compcode:this.$store.state.user.compcode,
                uraian:'', requisition:''},
        requestItem: {
            // items: [{reqdtlkey:'reqdtlkey1', partnumber:'icode001',jasa:'0', itemname:'master item#1', description:'deskripsi item1'},
            //         {reqdtlkey:'reqdtlkey2', partnumber:'icode002',jasa:'0', itemname:'master item#2', description:'deskripsi item2'}],
            items:[],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "partnumber",
                    label: "Master Item Code",
                    thStyle: "width:100px",
                    sortable: true
                },
                {
                    key: "itemname",
                    label: "Master Item Name",
                    thStyle: "width:240px",
                    sortable: true
                },
                {
                    key: "jasa",
                    label: "_",
                    thStyle: "width:80px",
                    sortable: true
                },
                {
                    key: "description",
                    label: "Description",
                    thStyle: "width:240px",
                },
                {
                    key: "quantity",
                    label: "Quantity",
                    thStyle: "width:90px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "groupNo",
                    label: "Grouping#",
                    thStyle: "width:60px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "selected",
                    label: "select",
                    thStyle: "width:20px",
                    sortable: true
                },

            ],
            page: 1,
            limit: 6,
            total: 0,
        },
        requestOrd: {
            items: [],
                // {requestno:'PR-001',requestdate:moment(Date()).startOf('month'),createby: 'ekok',remark: 'fasilitas backup data'}
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "requestno",
                    label: "Request Number",
                    thStyle: "width:100px",
                },
                {
                    key: "expected",
                    label: "Expected Date",
                    thStyle: "width:100px",
                },
                {
                    key: "requestby",
                    label: "Request By",
                    thStyle: "width:100px",
                },
                {
                    key: "remark",
                    label: "Description",
                    thStyle: "width:240px",
                },
                {
                    key: "vendorinfo",
                    label: "Recomended Supplier/Vendor",
                    thStyle: "width:200px",
                    thClass: "text-center",
                    // tdClass: "text-center"
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:30px",
                    thClass: "text-center",
                },
            ],
            total:0
        },
    };
},
  computed: {
    invalidRequestOrd() {
    //   this.requestOrd.kenappn= (this.requestOrd.ppn != 0); 
      this.$v.requestOrdObj.$touch();
      return this.$v.requestOrdObj.$invalid;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
  },
  watch: {
    selectAllItem: function(newval) {
        for (let index = 0; index < this.requestItem.items.length; index++) {
            this.requestItem.items[index].selected= newval;
        }
        // this.$forceUpdate();
    },     
  },
  created: async function(){
    //   this.currency = await proctender.currency();
    //   this.paymentTerms = await proctender.paymterms();
    if (this.$route.params.idTender)  {
          toastr.info('Loading Order Detail, please wait')
          try {
            this.isLoading=true;
            const data = await proctender.detailStep1(this.$route.params);  
            const row = data[0][0];
            this.isLoading=false;
            // this.saveEnabled=(row.send2wf === 0);
            row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.requestOrd.items = data[1];
            this.requestOrd.total=this.requestOrd.items.length;
            this.requestItem.items = data[2];
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
    } else {
        // router.push({name : "procurement.tendering"});
    } 
  },
  methods: {
    delRequestOrd: function (index) {
        if (index > -1) {
            const requestOrdObj= this.requestOrd.items[index];
            this.model.requisition='';
            const newLines = this.requestOrd.items.reduce((newArr, item) => {
                        if (item.requestkey !== requestOrdObj.requestkey) {
                            newArr.push(item);
                            if(this.model.requisition==''){
                                this.model.requisition=row.requestno
                            }else{
                                this.model.requisition+=','+row.requestno
                            }
                        }
                        return newArr;
                    }, []);
            this.requestItem.items=newLines;
            this.requestOrd.items.splice(index, 1);
            this.requestOrd.total=this.requestOrd.items.length;
        }
    },
    nextStep(){
      // update field status=2 to NEXT STEPS
      router.push({name :`procurement.tenderingfrm2`, params: { idTender: this.model.idTender}});              
    },
    save:  function () {
        return new Promise(async (resolve, reject) => {
            if (!this.saveEnabled) {
                // return;
                resolve();
            }
            this.isLoading=true;
            this.saveEnabled=false;            
            if (this.invalidModel) {
                console.log('validation : ', this.$v.model);
                console.log('model obj : ',this.model);
                toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
                this.saveEnabled=true;    
                this.isLoading=false;
                reject('Please fill the form correctly.');        
            } else {
                try {
                        this.model.idTender = this.model.idTender || '';
                        this.model.nomor = this.model.nomor || '';
                        const row = {};
                        var groupNoItemMatch=true;
                        for (var key in this.model) {
                            row[key] = this.model[key];
                        }
                        row.terms = this.model.terms;
                        row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                        row.lines = this.requestOrd.items;
                        var lineno=0;
                        
                        // request item selected
                        row.requestItems = this.requestItem.items.reduce((newArr, item) => {
                            if (item.selected) {
                                newArr.push(item);
                                lineno += 1;
                            }
                            return newArr;
                        }, []);
                        
                        row.requestItemsSmry = this.requestItem.items.reduce((newArr, item) => {
                            if (item.selected) {
                                if (!item.groupNo || item.groupNo===''|| item.groupNo===null) {
                                    newArr.push({
                                        itemno:item.itemno,
                                        spekdetail:item.description,
                                        QtyRequest:item.quantity,
                                        PackUnit:item.unitsize,
                                        qtyPurchase:item.quantity/(item.qtykonversi||1),
                                        groupNo:'', 
                                        reqdtlkey:item.reqdtlkey,
                                    });
                                    
                                }else{
                                    var findItmSmr = newArr.find(x=> x.groupNo == item.groupNo)
                                    if(findItmSmr){
                                        // check speck description
                                        if(findItmSmr.itemdesc !== item.description){
                                            groupNoItemMatch=false;
                                            toastr.error(`Detail Spesification Not Equal for All item : ${item.itemno} with group name : ${item.groupNo} `, 'ERROR MESSAGE');
                                        }else{
                                            findItmSmr.QtyRequest=findItmSmr.QtyRequest+item.quantity;
                                            findItmSmr.qtyPurchase=findItmSmr.qtyPurchase+item.quantity/(item.qtykonversi||1);
                                        }
                                    }else{
                                        newArr.push({
                                            itemno:item.itemno,
                                            spekdetail:item.description,
                                            QtyRequest:item.quantity,
                                            PackUnit:item.unitsize,
                                            qtyPurchase:item.quantity/(item.qtykonversi||1),
                                            groupNo:item.groupNo,
                                            reqdtlkey:''    
                                        });
                                    }  
                                }
                            }
                            return newArr;
                        }, []);


                        if ((row.lines.length>0) && (row.requestItems.length>0) && groupNoItemMatch) {
                            var result = await proctender.saveStep1of4(row);
                            var {data}=result;
                            this.model.idTender = data.idTender;
                            this.model.nomor = data.nomor;
                            toastr.success("Complete successfully", "Save Order");
                            this.isLoading=false;
                        } else {
                            if(groupNoItemMatch){
                                this.isLoading=false;
                                this.saveEnabled=true;            
                                toastr.error('Please fill at least 1(one) Request Order and one Requested Item', 'ERROR MESSAGE');
                            }
                        }
                        resolve();
                } catch (error) {
                    this.isLoading=false;
                    this.saveEnabled=true;            
                    console.log('error : ', error);
                    toastr.error(JSON.stringify(error), "Save Order Error");  
                    reject(error);              
                }
            }
        });
        
    },
    saveAndNext:async function(){
        // this.save()
        // setTimeout(() => {
        //     this.nextStep()            
        // }, 10000);
        try {
            await this.save();
            this.nextStep() ;        
            
        } catch (error) {
            console.log('error : ', error);
            toastr.error(JSON.stringify(error), "Save Order Error");              
        }

    },
    async onSelectLkuRequest(_selected) {
        var reqOrdItems = this.requestOrd.items;
        var reqOdrItmsIdx = reqOrdItems.find(x=>x.requestkey === _selected.requestkey)
        this.lkuRequisitionShow=false;
        if(reqOdrItmsIdx){
            toastr.error(`Purchase Request ${reqOdrItmsIdx.requestno} already exist`,'ERROR MESSAGE',10000);
        }else{
            try {
                this.model.jccostname = _selected.jccostname;
                this.model.budgetinfo = _selected.nomorintern+' | '+_selected.jccostname;
                this.model.nomorproduksi = _selected.noprodintern;
                this.model.ibudgdtkey = _selected.ibudgdtkey;
                this.model.ibudghdkey = _selected.ibudghdkey;
                this.model.pjxbudgkey = _selected.pjxbudgkey;
                this.model.pjxkey = _selected.pjxhdrkey;

                if (!(this.model.uraian)) {
                    this.model.uraian = _selected.remark;
                }
                const data = await proctender.requestdetail({ requestkey: _selected.requestkey }) ;
                var row = data[0][0]
                this.requestOrd.items.push(row);
                this.requestOrd.total=this.requestOrd.items.length;
                var reqItems = data[1]
                if(reqItems.length>0){
                    this.selectAllItem=true;
                }
                reqItems.forEach(element => {
                    element.selected=true;
                    this.requestItem.items.push(element)
                });

                if(this.model.requisition==''){
                    this.model.requisition=row.requestno
                }else{
                    this.model.requisition+=','+row.requestno
                }

            } catch (error) {
                this.isLoading=false;
                if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }
            }
            
        }
        
    },
    close(){
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'procurement.receivingfrm')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        // router.push({name:'payable.apinv'});
      router.push({name : "procurement.tendering"});
      }
    }
  }
};
</script>
